

import { Button, Col, Input, Row, Form, Checkbox, Tooltip, Radio, Space, Table, Tag, Modal, Switch, Dropdown, Menu } from "antd";
import { useEffect, useState } from "react";
import { EditOutlined, DeleteOutlined, MenuOutlined, PlusOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
import { setHeaderName } from "../../../../services/SetHeaderName";
// import { AddPlanPricing } from "./AddPlanPricing";

export const EmailTemplateList = () => {

    const data = [
        {
            id: '1001',
            name: 'Welcome Emailer',
            template_strings: '$ClientName, $NutritionistName, $Date, $PackageName',
            template: '<h1>Welcome $ClientName<h1>',
            userType: "Admin",
            status: false,
        },
        {
            id: '1002',
            name: 'Unable to Reach You',
            template_strings: '$ClientName, $NutritionistName, $Date, $PackageName',
            template: '<h1>Unable to Reach You $ClientName<h1>',
            userType: "Nutrionist",
            status: true,
        },
    ];

    const [dataSource, setDataSource] = useState(data);
    const [value, setValue] = useState('');


    useEffect(() => {
        setHeaderName("Email Templates")
        setDataSource(data)
    }, []);

    const onChange = (checked, data) => {
        // console.log(`switch to ${checked}`);
        // console.log(data.id);
    };

    const columns = [
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     key: 'name',
        //     defaultSortOrder: 'ascend',
        //     sorter: (a, b) => a.id - b.id,
        //     // render: (text) => <a>{text}</a>,
        // },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'active_client',
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            title: 'Template Strings',
            dataIndex: 'template_strings',
            key: 'template_strings',
            render: (_, { template_strings }) => (
                <>
                    {
                        template_strings.split(',').length > 0 &&
                        template_strings.split(',').map(tag => {
                            return (
                                <Tag color="blue" key={tag}>
                                    {tag}
                                </Tag>
                            );
                        })}
                </>
            ),
        },
        {
            title: 'User Type',
            dataIndex: 'userType',
            key: 'userType',
            filters: [
                { text: "Admin", value: "Admin" },
                { text: "Nutrionist", value: 'Nutrionist' },
            ],
            onFilter: (value, record) => record.userType == value,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={data.status} onChange={(e) => onChange(text, data)} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "Deactive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Link to={{ pathname: `/edit-email-template/${record.id}` }}>
                        <Button icon={<EditOutlined />} className="me-2" />
                    </Link>
                </div>
            ),
        },
    ];


    return (
        <>
            <div className="EmailTemplateList">
                <Row className="mb-2">
                    <Col md={4} xl={2} className="align-self-center">
                        <Link to={{ pathname: '/create-email-template' }} >
                            <Button htmlType="submit" className="submit-button  border-0 rounded ms-2 " icon={<PlusOutlined style={{ fontSize: "1.2rem" }} />}>
                                Add
                            </Button>
                        </Link>
                    </Col>
                    <Col md={8} xl={16} className="text-end align-self-center pe-4">
                        <h6 className="mb-0">Total Templates: 5 </h6>
                    </Col>
                    <Col md={12} xl={6} className="align-self-center pe-2">
                        <Input.Search placeholder="Search Users" onChange={e => {
                            let currValue = e.target.value;
                            setValue(currValue);
                            let filteredData = data.filter(entry =>
                                entry.name.toLowerCase().includes(currValue.toLowerCase()));
                            setDataSource(filteredData);
                        }} className="p-2" />
                    </Col>
                </Row>
                <Row>
                    <Table
                        columns={columns}
                        dataSource={dataSource}
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </div>
        </>
    )
}
